
<div class="iframe-container">
    <iframe class="iframe" id="externalPage"></iframe>
    <button mat-icon-button (click)="closeModal()">
        <img class="nav-icon" src="images/close.png" alt="profile" />            
    </button>
</div>
